<div class="vpa-wrapper">
  <div class="vpa">
    <img loading="lazy" src="/assets/images/vpa-img.png" />
    <div class="margin-30 open-upi">Open your UPI app to approve the payment request from Ketto</div>
    <div class="timer margin-30">{{countdown}} <span>mins</span></div>
    <div class="approve-text margin-30">Please approve the payment request before it times out</div>
  </div>
  <button (click)="cancelPayment()" class="cancel-payment" mat-button>Cancel Payment</button>
</div>